/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgTrello = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.25 3H4.75A1.75 1.75 0 0 0 3 4.75v10.5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 17 15.25V4.75A1.75 1.75 0 0 0 15.25 3Z",
        fill: "url(#Trello_svg__a)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14.34 4.82h-2.59a.84.84 0 0 0-.84.84v4.445c0 .464.376.84.84.84h2.59a.84.84 0 0 0 .84-.84V5.66a.84.84 0 0 0-.84-.84ZM8.25 4.82H5.66a.84.84 0 0 0-.84.84v7.945c0 .464.376.84.84.84h2.59a.84.84 0 0 0 .84-.84V5.66a.84.84 0 0 0-.84-.84Z",
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "Trello_svg__a",
        x1: 10,
        y1: 3,
        x2: 10,
        y2: 17,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#2684FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0152CC"
    }))));
export default SvgTrello;
